import { textConstants } from 'constants/texts';
import { useDeviceSize } from 'hooks/useDeviceSize';
import { useTruckerProps } from 'hooks/useTruckerProps';
import { useGlobals } from '../useGlobals';
import { AmplitudeData } from './types';

const useAmplitude = () => {
  const { isMobile, isTablet } = useDeviceSize();

  const { amplitude } = useGlobals();

  const { freight, eventsSource } = useTruckerProps();
  const device = isMobile || isTablet ? 'mobile' : 'desktop';

  const logEvent = (tag: string, payload: AmplitudeData) => {
    if ('freightCode' in payload && !freight?.code && !payload?.freightCode)
      payload.freightCode = textConstants.notAvailaible;
    if (!Boolean('source' in payload) && eventsSource) payload.source = eventsSource;
    amplitude().logEvent(tag, payload);
  };

  const sendAmplitude = (tag: string, payload?: AmplitudeData) => {
    logEvent(tag, { device, ...payload });
  };

  return {
    sendAmplitude,
  };
};

export { useAmplitude };
